var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2376_34)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 20.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0819 36.7337C21.6638 36.7337 19.3002 36.016 17.2894 34.6717C15.2788 33.3271 13.7117 31.4161 12.7863 29.1802C11.8608 26.9443 11.6186 24.4838 12.0902 22.1103C12.562 19.7365 13.7264 17.556 15.4361 15.8446C17.1459 14.1332 19.3243 12.9677 21.6961 12.4955C24.0677 12.0232 26.526 12.2656 28.7597 13.1916C30.9936 14.1178 32.9032 15.6863 34.2467 17.6986C35.59 19.711 36.3072 22.0769 36.3072 24.4972C36.3034 27.7413 35.0143 30.8515 32.7226 33.1457C30.4307 35.4397 27.3231 36.7297 24.0819 36.7337ZM24.4717 11H23.6922C20.1496 11.1028 16.7898 12.5969 14.339 15.1592C11.8881 17.7212 10.5429 21.1459 10.5942 24.6928C10.6456 28.2398 12.0895 31.6238 14.6135 34.114C17.1377 36.6041 20.5394 38 24.0837 38C27.6276 38 31.0292 36.6041 33.5533 34.114C36.0773 31.6242 37.5212 28.2398 37.5726 24.6928C37.6239 21.1461 36.2789 17.7211 33.8278 15.1592C31.377 12.5969 28.0174 11.1028 24.4746 11H24.4717ZM27.7132 28.0211C27.7132 26.6252 26.3941 25.4232 24.7153 25.1768V30.848C26.4267 30.568 27.7132 29.4074 27.7132 28.0211ZM20.4513 20.9725C20.4513 22.3681 21.7705 23.5707 23.4493 23.8167V18.1456C21.7375 18.4257 20.4513 19.5858 20.4513 20.9725ZM27.7844 19.9222C27.945 20.2326 28.3266 20.3541 28.6367 20.1932C28.9468 20.0325 29.068 19.6506 28.9075 19.3402C28.175 17.9242 26.5601 16.9718 24.7149 16.8332V15.4134C24.7185 15.2432 24.6535 15.0786 24.5345 14.9569C24.4155 14.8352 24.2526 14.7666 24.0824 14.7666C23.9123 14.7666 23.7492 14.8352 23.6302 14.9569C23.5112 15.0786 23.4463 15.2432 23.45 15.4134V16.867C22.4559 16.9843 21.5129 17.3708 20.722 17.9847C19.7742 18.6879 19.2064 19.7919 19.1851 20.9724C19.207 22.145 19.7626 23.2434 20.6944 23.9549C21.4844 24.5907 22.4406 24.9859 23.4488 25.0932V30.8911C22.0904 30.7595 20.8912 30.0619 20.3793 29.0725C20.2186 28.7621 19.837 28.6406 19.5268 28.8015C19.2167 28.9621 19.0955 29.3441 19.2563 29.6545C19.9887 31.0704 21.6032 32.0231 23.4488 32.1619V33.5814C23.4564 33.9256 23.7373 34.2008 24.0812 34.2008C24.4253 34.2008 24.7062 33.9256 24.7138 33.5814V32.1265C25.7075 32.0084 26.6505 31.6221 27.4418 31.0086C28.4007 30.3201 28.9719 29.2129 28.9772 28.0314C28.9828 26.8501 28.4222 25.7376 27.4696 25.0398C26.6795 24.4035 25.7233 24.0076 24.7149 23.8997V18.1038C26.0736 18.2354 27.2721 18.9329 27.7844 19.9222Z",
    fill: "#6A7988",
    stroke: "white",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2376_34",
    x: 0,
    y: 0,
    width: 49,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.468733 0 0 0 0 0.51145 0 0 0 0 0.554167 0 0 0 0.39 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2376_34"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2376_34",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillable);
export default __webpack_public_path__ + "static/media/billable.22a592c08556f2bcb0247478afc529a4.svg";
export { ForwardRef as ReactComponent };